export const filterTypes = {
  SORT: 'SORT',
  USERS: 'USERS',
  PUBLICATION: 'PUBLICATION',
};
